/// <amd-module name="Repos/CommitsList/Components/HistoryGraphHelper" />
import { ExcisionVisComponents, VisComponents } from "./HistoryGraphCell.Props";

/**
 * Helper class for VisComponents
 */
export class VisComponentsHelper {
    /**
     * Sets the given components in the base components provided and returns the result
     * @param base
     * @param componentsToSet
     */
    public static SetComponents(base: VisComponents, componentsToSet: VisComponents): VisComponents {
        base |= componentsToSet;
        return base;
    }

    /**
     * UnSets the given components from the base components provided and returns the result
     * @param base
     * @param componentsToUnSet
     */
    public static UnsetComponents(base: VisComponents, componentsToUnSet: VisComponents): VisComponents {
        base &= ~componentsToUnSet;
        return base;
    }

    /**
     * Checks if the given component is present in the base components
     * @param base - e.g. 7
     * @param query - e.g. VisComponents.TopMiddle. Will return true.
     */
    public static HasComponent(base: VisComponents, query: VisComponents): boolean {
        return (base & query) != 0;
    }

    /**
     * Converts the single VisComponents with multiple values into an array of individual VisComponents
     * @param components - e.g. 3 => [ VisComponents.TopLeft, VisComponents.TopMiddle ]
     */
    public static ToList(components: VisComponents): VisComponents[] {
        const keys = Object.keys(VisComponents).filter(k => typeof VisComponents[k as any] === "number"); // ["A", "B"]
        const values = keys.map(k => Number(VisComponents[k as any])); // [0, 1]
        return values.filter(value => VisComponentsHelper.HasComponent(components, value));
    }

    /**
     * Gets the VisComponents from the string provided
     * @param componentsString - String which holds the component values, e.g. "leftMiddle, rightMiddle". Result => 136
     */
    public static GetComponentsFromString(componentsString: string): VisComponents {
        let base: VisComponents = VisComponents.None;
        componentsString = componentsString.toLowerCase();

        Object.keys(VisComponents)
            .map(function(k: string) {
                return k.toLowerCase();
            })
            .forEach((individualComponent: string) => {
                const enumValue = parseInt(individualComponent);

                if (!isNaN(enumValue)) {
                    base = VisComponentsHelper.SetComponents(base, enumValue as VisComponents);
                }
            });

        return base;
    }
}

/**
 * Helper class for ExcisionVisComponents
 */
export class ExcisionVisComponentsHelper {
    /**
     * Sets the given excision components in the base excision components provided and returns the result
     * @param base
     * @param excisionComponentsToSet
     */
    public static SetComponents(base: ExcisionVisComponents, excisionComponentsToSet: ExcisionVisComponents): ExcisionVisComponents {
        base |= excisionComponentsToSet;
        return base;
    }

    /**
     * UnSets the given excision components from the base excision components provided and returns the result
     * @param base
     * @param excisionComponentsToUnSet
     */
    public static UnsetComponents(base: ExcisionVisComponents, excisionComponentsToUnSet: ExcisionVisComponents): ExcisionVisComponents {
        base &= ~excisionComponentsToUnSet;
        return base;
    }

    /**
     * Checks if the given excision component is present in the base excision components
     * @param base - e.g. 7
     * @param query - e.g. ExcisionVisComponents.IncomingExcision. Will return true.
     */
    public static HasComponent(base: ExcisionVisComponents, query: ExcisionVisComponents): boolean {
        return (base & query) != 0;
    }
    /**
     * Converts the single VisComponents with multiple values into an array of individual VisComponents
     * @param components - e.g. 3 => [ VisComponents.TopLeft, VisComponents.TopMiddle ]
     */
    public static ToList(components: ExcisionVisComponents): ExcisionVisComponents[] {
        const keys = Object.keys(ExcisionVisComponents).filter(k => typeof ExcisionVisComponents[k as any] === "number"); // ["A", "B"]
        const values = keys.map(k => Number(ExcisionVisComponents[k as any])); // [0, 1]
        return values.filter(value => ExcisionVisComponentsHelper.HasComponent(components, value));
    }

    /**
     * Gets the ExcisionVisComponents from the string provided
     * @param excisionComponentsString - String which holds the component values, e.g. "outgoingExcision, incomingExcision". Result => 3
     */
    public static GetComponentsFromString(excisionComponentsString: string): ExcisionVisComponents {
        let base: ExcisionVisComponents = ExcisionVisComponents.None;
        excisionComponentsString = excisionComponentsString.toLowerCase();

        Object.keys(ExcisionVisComponents)
            .map(function(k: string) {
                return k.toLowerCase();
            })
            .forEach((individualComponent: string) => {
                const enumValue = parseInt(individualComponent);

                if (!isNaN(enumValue)) {
                    base = ExcisionVisComponentsHelper.SetComponents(base, enumValue as ExcisionVisComponents);
                }
            });

        return base;
    }
}
